import React, { useEffect } from "react";

function cls(...xs) {
  return xs.filter(Boolean).join(" ");
}

function getScrollbarWidth() {
  try {
    return window.innerWidth - document.documentElement.clientWidth;
  } catch {
    return 0;
  }
}

export default function OpsRightDrawer({ open, title, subtitle, width = 820, onClose, children }) {
  // ESC closes
  useEffect(() => {
    if (!open) return;
    const onKey = (e) => {
      if (e.key === "Escape") onClose?.();
    };
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, [open, onClose]);

  // lock background scroll + prevent layout shift
  useEffect(() => {
    if (!open) return;
    const prevOverflow = document.body.style.overflow;
    const prevPad = document.body.style.paddingRight;

    const sw = getScrollbarWidth();
    document.body.style.overflow = "hidden";
    if (sw > 0) document.body.style.paddingRight = `${sw}px`;

    return () => {
      document.body.style.overflow = prevOverflow || "";
      document.body.style.paddingRight = prevPad || "";
    };
  }, [open]);

  return (
    <div className={cls("fixed inset-0 z-[70]", !open && "pointer-events-none")}>
      {/* overlay */}
      <div
        onClick={onClose}
        className={cls("absolute inset-0 transition-opacity", open ? "opacity-100 bg-black/35" : "opacity-0 bg-black/0")}
      />

      {/* panel */}
      <div
        className={cls(
          "absolute right-0 top-0 h-full bg-white shadow-2xl border-l border-slate-200 transition-transform",
          open ? "translate-x-0" : "translate-x-full"
        )}
        style={{ width: `min(${width}px, 96vw)` }}
      >
        <div className="h-full flex flex-col">
          {/* header */}
          <div className="sticky top-0 z-10 bg-white border-b border-slate-200">
            <div className="px-5 py-4 flex items-start justify-between gap-3">
              <div className="min-w-0">
                <div className="text-[12px] font-semibold tracking-wider text-slate-500">Review panel</div>
                <div className="mt-1 text-xl font-semibold tracking-tight text-slate-900 truncate">
                  {title || "Details"}
                </div>
                {subtitle ? <div className="mt-1 text-sm text-slate-600 truncate">{subtitle}</div> : null}
              </div>

              <button
                className="h-9 rounded-md border border-slate-200 px-3 text-sm font-semibold hover:bg-slate-50"
                onClick={onClose}
                type="button"
              >
                Close
              </button>
            </div>
          </div>

          <div className="flex-1 overflow-auto bg-slate-50/30">{children}</div>
        </div>
      </div>
    </div>
  );
}
